import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { ShareResourceEnum } from '../enum/share-resource-enum';
import { ShareResourceInterface, ShareResourceNewFlowInterface } from '../types/share-interface';
import { getResourceApiSlug } from '../utils/get-resource-api-slug';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
export const useShareResource = t0 => {
  const $ = _c(13);
  const {
    hash,
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = getResourceApiSlug(type);
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resourceApiSlug = t1;
  const isNewFlow = type === ShareResourceEnum.Workflow;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get,
      badRequestHandler(error) {
        throw error;
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher
  } = useFetch(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.post,
      badRequestHandler(error_0) {
        throw error_0;
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    fetcher: postNewFlowFetcher
  } = useFetch(t3);
  let t4;
  if ($[4] !== hash || $[5] !== resourceApiSlug || $[6] !== type) {
    t4 = () => {
      if (!hash || !type) {
        return;
      }
      switch (resourceApiSlug) {
        case ShareResourceEnum.Funnel:
          {
            return `/api/funnel/share-background/${hash}`;
          }
        case ShareResourceEnum.Blog:
          {
            return `/api/blog/share-background/${hash}`;
          }
        default:
          {
            return `/api/${resourceApiSlug}/share/${hash}`;
          }
      }
    };
    $[4] = hash;
    $[5] = resourceApiSlug;
    $[6] = type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data: oldFlowData,
    error: oldFlowError
  } = useControlledSwr(t4, fetcher, undefined, !isNewFlow);
  let t5;
  if ($[8] !== hash) {
    t5 = () => {
      if (!hash) {
        return;
      }
      return `/api/dashboard/sharing/share/${hash}`;
    };
    $[8] = hash;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data: newFlowData,
    error: newFlowError
  } = useControlledSwr(t5, postNewFlowFetcher, undefined, isNewFlow);
  const t6 = isNewFlow ? newFlowData : oldFlowData;
  const t7 = isNewFlow ? newFlowError : oldFlowError;
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = {
      data: t6,
      error: t7
    };
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};